export default __webpack_public_path__ + "static/media/device-ELS-128x128.0534d7e7.png";